import { useRemoteField } from "../../hooks/useRemoteField";
import { ESRFieldProps } from "../../types/data";
import { Checkbox, Chip, FormControl, IconButton, InputLabel, ListItemText, MenuItem, Select, TextField, } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useState } from "react";

export const ESRDynamicMultiSelectField = (props : ESRFieldProps) =>{
    const { question_id, hint_value, locked, required } = props;
    const [value, setValue, setLocalValue] = useRemoteField(question_id);
    const [optionsStr] = useRemoteField(`${question_id}.OPTIONS`);
    const [customValue, setCustomValue] = useState("");
    let options: string[] = [];

    try {
		options = JSON.parse(optionsStr);
	} catch {}

    let selections: string[] = [];
    try {
        let selectable_values = JSON.parse(value)
        // to allow backward compatibility if previous options were stored using ESRDynamicSelectField
		selections = Array.isArray(selectable_values) ? selectable_values : [selectable_values].map((item)=>item.toString());
	} catch {}

    const toggleSelection = (optionValue: string)=>{
        selections = selections.includes(optionValue) ? selections.filter((val) => val !== optionValue) : [...selections, optionValue];
        setValue(JSON.stringify(selections));
    }
    const handleAddCustomValue = () => {
        if (customValue.trim() && !selections.includes(customValue.trim())) {
            selections = [...selections, customValue.trim()];
            setCustomValue("");
            setValue(JSON.stringify(selections));
        }
    };

    return  (
		<>
            <FormControl fullWidth>
			<InputLabel>Please select value(s)</InputLabel>
			<Select
                    id={question_id}
                    aria-labelledby={question_id}
                    multiple
                    error={!value}
                    disabled={locked > 0}
                    value={selections}
                    label="Please select value(s)"
                    renderValue={
                        ()=>(
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                {selections.map((val) => {
                                    return (
                                        <Chip key={val} label={val}/>
                                    )
                                })}
                            </div>
                        )
                    }
                >
                    {options.map((o) => (
                        <MenuItem key={o} value={o} onClick={() => toggleSelection(o)}>
                            <Checkbox checked={selections.includes(o)} />
                            <ListItemText primary={o} />
                        </MenuItem>
                    ))}
                    <MenuItem>
                        <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            placeholder="Add additional PPS#"
                            value={customValue}
                            onChange={(e) => setCustomValue(e.target.value)}
                            onKeyDown={(e) => e.key === "Enter" && handleAddCustomValue()}
                        />
                        <IconButton
                                  color="primary"
                                  onClick={handleAddCustomValue}
                                  size="small"
                                  sx={{ p: 0, marginLeft: 8 }}
                                >
                                <AddCircleIcon />
                        </IconButton>
                    </MenuItem>
                </Select>
            </FormControl>
        </>
	);
}